import React from 'react'
import colors from '@settings/styleSettings'
import { View, StyleSheet, Text } from '@react-pdf/renderer'

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center',
    fontSize: 10,
    color: colors.strongGray,
  },
})

// Create Document Component
export const Footer = () => (
  <View style={styles.container}>
    <Text style={{ padding: 2 }}>Medicina Preventiva - Unimed Assis</Text>
    <Text style={{ padding: 2 }}>
      Avenida Walter Antônio Fontana, 1997, Vila Cláudia - Assis/SP
    </Text>
    <Text style={{ padding: 2 }}>
      E-mail: medicina.preventiva@unimed-assis.com.br
    </Text>
    <Text style={{ padding: 2 }}>Telefone: (18) 99709-1663</Text>
  </View>
)
